import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import FeedbackForm from "./feedbackComponents/FeedbackForm";

import { useCreateFeedbackMutation } from "store/services/feedbackApi";

import { useAppMeta } from "hooks";

const FeedbackCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Feedbacks", path: "/app/crm/feedback/list" },
    { title: "New Feedback" },
  ];

  // RTK Query
  const [createFeedback, { isLoading: creatingFeedback }] =
    useCreateFeedbackMutation();

  // methods
  const handleAddFeedback = async (data) => {
    try {
      const { _id } = await createFeedback(data).unwrap();
      toast.success("Feedback successfully created!");
      navigate(`/app/crm/feedback/${_id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't create feedback!");
    }
  };

  useAppMeta("New Feedback");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingFeedback}>
      <BreadcrumbLayout.Paper>
        <FeedbackForm onSubmit={handleAddFeedback} isBusy={creatingFeedback} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default FeedbackCreateScreen;
